/**
 * Ambient Media Service
 * Handles API calls for restaurant ambient photo/video management
 */

import { api } from '@/lib/axios';
import { directUpload } from './directUpload';

export interface AmbientMedia {
  id: string;
  blob_id: number;
  url: string;
  original_url?: string;
  filename: string;
  content_type: string;
  byte_size: number;
  created_at: string;
  attachment_id?: string;
  crop_data?: { x: number; y: number; width: number; height: number };
  viewport_position?: { x: number; y: number };
  optimization_status?: 'red' | 'yellow' | 'green' | 'error';
  processed_blob_id?: string;
}

export interface AmbientMediaListResponse {
  photos: AmbientMedia[];
}

export const ambientPhotoService = {
  async listPhotos(): Promise<AmbientMedia[]> {
    const response = await api.get<AmbientMediaListResponse>('/v1/admin/ambient_photos');
    return response.data.photos;
  },

  async uploadPhoto(
    file: File,
    onProgress?: (progress: number) => void
  ): Promise<AmbientMedia> {
    const signedBlobId = await directUpload({ file, onProgress });
    const response = await api.post<AmbientMedia>('/v1/admin/ambient_photos', {
      signed_blob_id: signedBlobId
    });
    return response.data;
  },

  async deletePhoto(photoId: string): Promise<void> {
    await api.delete(`/v1/admin/ambient_photos/${photoId}`);
  },

  async reorderPhotos(photoIds: string[]): Promise<void> {
    await api.post('/v1/admin/ambient_photos/reorder', {
      photo_ids: photoIds
    });
  }
};

export type AmbientPhoto = AmbientMedia;
